/**
 * Chosen, across the dashboard: a selected card, chip, row or tile is
 * outlined in the brand's dark green with no fill, never in ink (CEO, 24 Oct:
 * the black outline read as an error state, not a choice).
 *
 * One value, behind one token (--fvd-selected-border in globals.css, with its
 * light and dark values and the HYROX skin's), so a screen never picks its own
 * shade. The string is the same one the Volunteers redesign carries in its own
 * redesign/selected.ts, so the two read alike before and after that branch
 * lands; the fallback only matters where the token is missing.
 *
 * The chosen option of a pill toggle (FvdSegmented) is filled with the same
 * green, with SELECTED_ON for its label. Nothing else is filled: a selected
 * card keeps its ground.
 */
export const SELECTED_BORDER = 'var(--fvd-selected-border, var(--fvd-teal-solid))';

/** The label on a filled selected option (the pill toggle). */
export const SELECTED_ON = 'var(--fvd-selected-on, var(--fvd-teal-solid-on))';

/**
 * A whole border declaration: the green line when chosen, `off` when not.
 *
 *   border: selectedBorder(on)                                   (1px, control line)
 *   border: selectedBorder(on, 'var(--fvd-hairline)')            (a card's hairline)
 *   border: selectedBorder(on, 'transparent', 2)                 (a swatch ring)
 */
export function selectedBorder(on: boolean, off = 'var(--fvd-border-control)', width = 1): string {
  return `${width}px solid ${on ? SELECTED_BORDER : off}`;
}

/**
 * An outline for a selected tile in a grid (a photo), where a border would
 * shift the layout: the green ring when chosen, nothing when not.
 */
export function selectedOutline(on: boolean, width = 2): string | undefined {
  return on ? `${width}px solid ${SELECTED_BORDER}` : undefined;
}
